/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { useRef } from 'react'
import { FormikProps } from 'formik'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Lightbox } from '@nexigendigital/nxui'

import PasswordForm from 'containers/services/form/passwordForm'

/**********************************************************************************************************
 *   INTERFACE
 **********************************************************************************************************/
interface Props {
    id: number,
    status: boolean,
    close: () => void
}

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function PasswordLightbox({ id, status, close }: Props) {
    const formRef = useRef<FormikProps<{ password: string }>>(null)

    /*   RENDER COMPONENT
    **********************************************************************************************************/
    return (
        <Lightbox
            title={'Change PasswordLightbox'}
            content={<PasswordForm id={id} form={formRef} close={close}/>}
            conditions={{ state: status, action: () => close() }}
            links={[]}
            actions={[
                {
                    label: 'Back',
                    color: 'secondary',
                    func: () => close()
                },
                {
                    label: 'Change',
                    color: 'primary',
                    type: 'submit',
                    form: 'changePasswordForm'
                }
            ]}
        />
    )
}
